module.exports = __webpack_public_path__ + "img/15.b7f3b96.png";